import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import MyArmyListsComponent from "../../myBuilder/builder/MyArmyListsComponent";

const FolderMake: React.FC<FolderMakeProps> = ({folderId}) => {

  return (
    <section className="mt-2 text-center">
      <MyArmyListsComponent parentId={folderId}/>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  folderId: state.folder.id,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FolderMake);

type FolderMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>